import { getPointerType } from "@otto-ec/global-resources/device";
import { onReady } from "@otto-ec/global-resources/dom";
import type { Unsubscriber } from "svelte/store";
import { disableScrolling, enableScrolling } from "../../../../common/utils/scrollPrevention";
import { interactionScope } from "./utils";
import { stack } from "../stack/stack.global.svelte";

const scrollLog = /*           */ interactionScope.scope("document");

const deviceProps = $state({ isTouchable: false, domReady: false });
let documentScrollingDisabled = false;

/**
 *
 *
 */
export function useDeviceProperties(): {
  /**
 *
 */
  isTouchable: boolean;
} {
  getPointerType().then((pointerType) => {
    deviceProps.isTouchable = pointerType.isTouchable;
  });
  return deviceProps;
}

/**
 *
 *
 *
 *
 *
 */
export function useDocumentScrollBlock(): Unsubscriber {
  /*                                                                      */
  /*                                           */
  if (import.meta.env.STORYBOOK && window.parent !== window.self) {
    if (import.meta.env.DEV)
      scrollLog.warn("running in storybook frame, skipping document scroll block");
    return () => {};
  }

  if (import.meta.env.DEV)
    scrollLog.info("Instanciating document scroll block, wait for dom ready");

  /*                                                                              */
  onReady.sub(
    () => {
      if (import.meta.env.DEV) scrollLog.info("Document ready, setting up document scroll block");
      deviceProps.domReady = true;
    },
    { once: true },
  );

  return $effect.root(() => {
    $effect(() => {
      const blockScroll = !!stack.current;

      /*                       */
      if (!deviceProps.domReady) return;

      /*                                                       */
      if (blockScroll && !documentScrollingDisabled) {
        if (import.meta.env.DEV) scrollLog.info("Disabling document scrolling");
        disableScrolling();
      }

      if (!blockScroll && documentScrollingDisabled) {
        if (import.meta.env.DEV) scrollLog.info("Enabling document scrolling");
        enableScrolling();
      }

      documentScrollingDisabled = blockScroll;
    });
  });
}
